import { create } from 'zustand';

interface WhatsNewState {
  open: boolean;
  openWhatsNew: () => void;
  closeWhatsNew: () => void;
}

/** One "What's new" dialog, opened from the sidebar version or the update notice. */
export const useWhatsNewStore = create<WhatsNewState>()((set) => ({
  open: false,
  openWhatsNew: () => {
    set({ open: true });
  },
  closeWhatsNew: () => {
    set({ open: false });
  },
}));
